import Config from "@skin_config";
import { getAuthData } from "@common/helpers/auth";
import { getMerchantId } from "@app/dev/helpers/okto";

// format amount to XXXXXXYYYY
const formatCashoutAmount = (amount) => {
  if (!amount) return "";

  const [integerPart, fractionalPart] = amount.toString().split(".");
  let amountToCashout = +integerPart;

  amountToCashout = String(amountToCashout).padStart(6, "0");

  if (fractionalPart) amountToCashout += fractionalPart;

  return amountToCashout;
};

export const getOktoQrData = (classId, operationId, amount) => {
  const authData = getAuthData();
  const tid = authData.tid.toString();

  const qrData = {
    merchantId: getMerchantId(), // merchant from sit oktopay
    classId,
    operationId,
    currency: "RON",
    totalFee: "000000",
    totalAmount: formatCashoutAmount(amount),
    referenceId: tid,
    other: {
      extSysData: JSON.stringify({
        tid,
        currency: "RON",
      }),
    },
  };

  return qrData;
};
